// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__Cg_mc","value":"Results_value__6Rsr4","description":"Results_description__OOkly","capability":"Results_capability__fdJky"};